import { createStyles, type WithStyles, withStyles } from "@material-ui/core";
import React from "react";
import { AppBar, AppBarConteudoDefault, TabContentDefault } from "../../layout";
import { NavigationTabs } from "../../navegacao";
import { SelectedFarmContainer } from "../../shared/crossCuttingComponents";
import { useHerdControlTabs } from "../hooks/useHerdControlTabs";
import HerdControlTabsContent from "./herdControlTabsContent";

type HerdControlPageProps = WithStyles<typeof styles>;

function HerdControlPage({ classes }: HerdControlPageProps) {
  const { handleChangeTab, selectedTab, tabs } = useHerdControlTabs();

  return (
    <>
      <AppBar
        conteudoCustomizadoAppBar={
          <SelectedFarmContainer
            render={(farm, { noFarmSelectedTitle }) => (
              <AppBarConteudoDefault
                tituloAppBar={farm?.NomeReduzido ?? noFarmSelectedTitle}
              />
            )}
          />
        }
      />

      <NavigationTabs
        classNames={{ paper: classes.tabsPaper }}
        tabs={tabs}
        onTabChange={handleChangeTab}
        selectedTab={selectedTab}
      />
      <div className={classes.contentWrapper}>
        <TabContentDefault>
          <HerdControlTabsContent selectedTab={selectedTab} />
        </TabContentDefault>
      </div>
    </>
  );
}

const styles = () =>
  createStyles({
    contentWrapper: {
      width: "100%",
    },
    tabsPaper: {
      backgroundColor: "#f8f8f8",
      minHeight: 60,
      display: "flex",
      alignItems: "center",
      boxShadow: "unset",
    },
  });

export default withStyles(styles)(HerdControlPage);
